(function() {
  var TARGET_PRODUCT = 'english-willow-cricket-bat-force-g1-below-12y-demo-for-3d';

  var currentHandle = window.location.pathname.split('/products/')[1];
  if (!currentHandle) return;
  currentHandle = currentHandle.split('?')[0].split('/')[0];
  if (currentHandle !== TARGET_PRODUCT) return;

  // ✅ Sliding band karo + fade effect
  var style = document.createElement('style');
  style.textContent = '.swiper-wrapper-preview .swiper-wrapper { transition-duration: 0ms !important; } .swiper-wrapper-preview { transition: opacity 0.3s ease !important; }';
  document.head.appendChild(style);

  var productData = null;

  function init() {
    var jsonEl = document.querySelector('.productJson');
    if (!jsonEl) return;
    try { productData = JSON.parse(jsonEl.textContent); } catch(e) { return; }

    var attempts = 0;
    var waitForSwiper = setInterval(function() {
      attempts++;
      var galleryEl = document.querySelector('.swiper-wrapper-preview');
      if ((galleryEl && galleryEl.swiper) || attempts > 20) {
        clearInterval(waitForSwiper);
        attachListeners();
      }
    }, 300);
  }

  function attachListeners() {
    // Variant picker clicks
    document.querySelectorAll('.product-detail__variant-picker').forEach(function(picker) {
      picker.addEventListener('click', function() { setTimeout(findAndJump, 150); });
      picker.addEventListener('change', function() { setTimeout(findAndJump, 150); });
    });
    // Theme events
    document.addEventListener('variant:change', function(e) {
      if (e.detail && e.detail.variant) jumpToImage(e.detail.variant);
    });
    document.addEventListener('variantChange', function(e) {
      if (e.detail && e.detail.variant) jumpToImage(e.detail.variant);
    });
  }

  function findAndJump() {
    if (!productData) return;
    var chosen = [];
    document.querySelectorAll('.product-detail__variant-picker input[type="radio"]:checked').forEach(function(inp) {
      chosen.push(inp.value);
    });
    document.querySelectorAll('.product-detail__variant-picker select').forEach(function(sel) {
      if (sel.value) chosen.push(sel.value);
    });
    document.querySelectorAll('.product-detail__variant-picker .active, .product-detail__variant-picker [aria-checked="true"], .product-detail__variant-picker .selected').forEach(function(el) {
      var val = el.getAttribute('data-value') || el.textContent.trim();
      if (val && chosen.indexOf(val) === -1) chosen.push(val);
    });
    if (!chosen.length) return;
    var best = findBestVariant(chosen);
    if (best) jumpToImage(best);
  }

  function findBestVariant(chosenValues) {
    var best = null, bestScore = -1;
    productData.variants.forEach(function(v) {
      var score = 0;
      [v.option1, v.option2, v.option3].filter(Boolean).forEach(function(opt) {
        if (chosenValues.indexOf(opt) !== -1) score++;
      });
      if (score > bestScore && v.featured_image) { bestScore = score; best = v; }
    });
    return best;
  }

  function jumpToImage(variant) {
    if (!variant || !variant.featured_image) return;

    var galleryEl = document.querySelector('.swiper-wrapper-preview');
    if (!galleryEl || !galleryEl.swiper) return;

    var swiper = galleryEl.swiper;
    var slides = galleryEl.querySelectorAll('.swiper-slide');

    // Target index dhundho
    var targetIndex = -1;
    var targetBase = variant.featured_image.src.split('?')[0].split('/').pop().split('_')[0];

    slides.forEach(function(slide, i) {
      if (targetIndex !== -1) return;
      var link = slide.querySelector('a[href]');
      if (link && link.getAttribute('href').indexOf(targetBase) !== -1) { targetIndex = i; return; }
      var img = slide.querySelector('img');
      if (img) {
        var src = img.getAttribute('src') || img.src || '';
        if (src.indexOf(targetBase) !== -1) { targetIndex = i; return; }
      }
    });

    // Fallback position
    if (targetIndex === -1 && variant.featured_image.position) {
      targetIndex = variant.featured_image.position - 1;
    }

    if (targetIndex === -1 || targetIndex === swiper.activeIndex) return;

    // ✅ Fade out → instant jump → fade in
    galleryEl.style.opacity = '0';
    setTimeout(function() {
      swiper.slideTo(targetIndex, 0, false);
      // Thumbnail sync
      try {
        var thumbEl = document.querySelector('.thumbnail-slide');
        if (thumbEl && thumbEl.swiper) thumbEl.swiper.slideTo(targetIndex, 0, false);
      } catch(e) {}
      setTimeout(function() {
        galleryEl.style.opacity = '1';
      }, 50);
    }, 200);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    setTimeout(init, 500);
  }
})();